var map = {
	"./logo-12up.embedded.svg": 539,
	"./logo-90min.embedded.svg": 540,
	"./logo-dbltap.embedded.svg": 541,
	"./logo-ei.embedded.svg": 542,
	"./logo-floor8.embedded.svg": 543,
	"./logo-ftb90.embedded.svg": 544,
	"./logo-german_site.embedded.svg": 545,
	"./logo-ht_media.embedded.svg": 546,
	"./logo-pluralist.embedded.svg": 547,
	"./logo-theduel-mobile.embedded.svg": 548,
	"./logo-theduel.embedded.svg": 549
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1322;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/logo\-.*\.embedded\.svg$
// module id = 1322
// module chunks = 15